












































































import Vue from "vue";
import Component from "vue-class-component";
import SectionLayout from "../SectionLayout.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    SectionLayout
  }
})
export default class HomeFooter extends Vue {
  @Prop({ required: true, default: "" }) image!: string;
  inspiring: string = this.getRandomQuotes();

  getRandomQuotes(): string {
    const authors = [
      "ayrton_senna",
      "c_s_lewis",
      "dalai_lama",
      "confucio",
      "muhammad_ali",
      "theodore_roosevelt",
      "fernando_sabino",
      "aristoteles",
      "winston_churchill",
      "frida_kahlo",
      "michelle_obama",
      "michael_jordan",
      "albert_einstein",
      "stephen_hawking",
      "bill_gates_one",
      "napoleao_bonaparte",
      "henry_ford_one",
      "santo_agostinho",
      "oscar_wilde",
      "john_f_kennedy",
      "bill_gates_two",
      "henry_ford_two",
      "walt_disney",
      "martin_luther_king"
    ];
    const randomAuthor = authors[Math.floor(Math.random() * authors.length)];
    return `footer.inspiring.${randomAuthor}`;
  }

  // animate(direction: string) {
  //   const vh = window.innerHeight / 2;
  //   const vw = window.innerWidth / 2;
  //   const elements = Array.from(this.$el.querySelectorAll('span'));
  //   const tl = new TimelineMax({delay: 0.25}).staggerFrom(
  //           elements,
  //           1.25,
  //           {
  //             opacity: 0,
  //             cycle: {
  //               x: [-(vw / 2) - 100, 0, vw / 2 + 100, 0],
  //               y: [0, -vh / 2 - 100, 0, vh / 2 + 100]
  //             },
  //             ease: Back.easeOut
  //           },
  //           0.1
  //   );
  // }

  get years() {
    return [2017, new Date().getFullYear()].join(" - ");
  }

  get isMobile() {
    // @ts-ignore
    return this.$vuetify.breakpoint.smAndDown;
  }

  mounted() {}
}
